import { UNKNOWN_MIME_TYPE, getExtension } from '@inno-sdks/mime-types'

/**
 * Triggers the download of a file, either from a URL string or a Blob object.
 *
 * @param {string | Blob} file - The file to download. Can be a URL string or a Blob.
 * @param {string} [fileName] - Optional filename for the downloaded file. Defaults to `'unknown'`.
 */
export function downloadFile(file: string | Blob | File, fileName?: string) {
  const a = document.createElement('a')

  const isString = typeof file === 'string'

  const url = isString ? (file as string) : URL.createObjectURL(file as File)

  let _fileName = fileName

  if (!_fileName && file instanceof File) {
    const baseName = file.name
    const ext =
      file.type === UNKNOWN_MIME_TYPE ? undefined : getExtension(file.type)

    _fileName =
      !ext || baseName.toLowerCase().endsWith(`.${ext}`)
        ? baseName
        : `${baseName}.${ext}`
  }

  a.href = url
  a.setAttribute('download', _fileName ?? 'unknown')

  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)

  if (!isString) {
    URL.revokeObjectURL(url)
  }
}
